// 二维码类型枚举
export enum QRCodeType {
    WL,
    CK,
    HW,
    GD,
    GZ,
    SB,
    YG,
    ZKD,
    CKD,
    RKD
}

// 工装/仓库/货位属性编码
export enum Attribute {
    HH = 'APPLIANCE_MIX',
    HG = 'APPLIANCE_ONTEST',
    BL = 'APPLIANCE_OFFTEST',
    BF = 'APPLIANCE_USELESS'
}

